import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText,
} from "@mui/material";
import { CartItemUnavailable } from "../../models/CartServiceType";
import AsyncString from "../../shared/asyncString";

interface UnavailableItemsDialogProps {
    open: boolean;
    onClose: () => void;
    restaurantId: string;
    unavailableItems: CartItemUnavailable[];
}

const UnavailableItemsDialog: React.FC<UnavailableItemsDialogProps> = ({ open, onClose, restaurantId, unavailableItems }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Some Items Are No Longer Available</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    The following items are no longer available and have been removed from your cart:
                </DialogContentText>
                <List>
                    {unavailableItems.map((item, index) => (
                        <ListItem key={index}>
                            {
                                item.saleItem ?
                                    <ListItemText
                                        primary={<AsyncString stringId={"restaurant-" + restaurantId + "-saleItem-" + item.saleItem.id + "-sale-item-name"} />}
                                        secondary={`Requested: ${item.requested}, Available: ${item.available}`}
                                    />
                                    :
                                    <ListItemText
                                        primary={"Unknown sale Item"}
                                        secondary={`Requested: ${item.requested}, Available: ${item.available}`}
                                    />
                            }
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UnavailableItemsDialog;
